import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { siteInfo } from "@/mocks/gossipData";

const NAV_ITEMS = [
  { to: "/", label: "首页" },
  { to: "/gossip", label: "吃瓜合集" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

const TICKER = [
  "今日已更新 4 篇盘点",
  "音乐节高光时刻合集上线",
  "社交平台热门挑战盘点发布",
  "黄金配角盘点持续走高",
  "网络流行语年度盘点已更新",
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="w-full overflow-hidden bg-foreground-950 py-1.5 text-background-100">
        <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap text-xs font-label">
          {[...TICKER, ...TICKER].map((item, index) => (
            <span key={`${item}-${index}`} className="flex items-center gap-2">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500" aria-hidden="true" />
              {item}
            </span>
          ))}
        </div>
      </div>

      <div
        className={`w-full border-b transition-colors duration-300 ${
          scrolled
            ? "border-background-200 bg-background-50/95 backdrop-blur"
            : "border-transparent bg-background-50"
        }`}
      >
        <div className="flex h-16 items-center justify-between px-4 md:h-[72px] md:px-6">
          <Link to="/" className="flex items-center gap-3 cursor-pointer group">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50 transition-transform group-hover:-rotate-6">
              <i className="ri-leaf-line text-xl" aria-hidden="true" />
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-xl text-foreground-950">{siteInfo.name}</span>
              <span className="hidden text-[11px] text-foreground-500 sm:block">
                {siteInfo.tagline}
              </span>
            </span>
          </Link>

          <nav aria-label="主导航" className="hidden items-center gap-1 md:flex">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-full px-4 py-2 text-sm font-label transition-colors cursor-pointer ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-200"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/gossip"
              className="hidden whitespace-nowrap items-center gap-1.5 rounded-full bg-foreground-950 px-4 py-2 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 md:flex cursor-pointer"
            >
              <i className="ri-fire-line" aria-hidden="true" />
              开始吃瓜
            </Link>
            <button
              type="button"
              onClick={() => setOpen((prev) => !prev)}
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
              className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 md:hidden cursor-pointer"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
            </button>
          </div>
        </div>

        {open && (
          <nav
            aria-label="移动端导航"
            className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden"
          >
            <ul className="flex flex-col gap-1">
              {NAV_ITEMS.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    end={item.to === "/"}
                    className={({ isActive }) =>
                      `block whitespace-nowrap rounded-lg px-4 py-3 text-sm font-label transition-colors cursor-pointer ${
                        isActive
                          ? "bg-primary-100 text-primary-700"
                          : "text-foreground-700 hover:bg-background-100"
                      }`
                    }
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
              <li>
                <Link
                  to="/gossip"
                  className="mt-1 block whitespace-nowrap rounded-lg bg-foreground-950 px-4 py-3 text-center text-sm font-label text-background-50 cursor-pointer"
                >
                  开始吃瓜
                </Link>
              </li>
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
}